import { render, staticRenderFns } from "./adminSeckill.vue?vue&type=template&id=1ef7b801&scoped=true"
import script from "./adminSeckill.vue?vue&type=script&lang=js"
export * from "./adminSeckill.vue?vue&type=script&lang=js"
import style0 from "./adminSeckill.vue?vue&type=style&index=0&id=1ef7b801&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef7b801",
  null
  
)

export default component.exports